module.exports = __webpack_public_path__ + "assets/img/angelinvestmentnetwork.7a8d2b9b.svg";